import { useCreateAdjustmentBase } from "./useCreateAdjustmentBase"

import type {
  CreateAdjustQuantityInput,
  CreateInventoryQuantityAdjustmentMutation,
  CreateInventoryQuantityAdjustmentMutationVariables,
} from "@/graphql/codegen/graphql"
import { CreateInventoryQuantityAdjustmentDocument } from "@/graphql/codegen/graphql"

interface UseCreateQuantityAdjustmentReturn {
  createAdjustment: (input: CreateAdjustQuantityInput, comment?: string, document?: File) => Promise<boolean>
  isCreating: boolean
}

export const useCreateQuantityAdjustment = (): UseCreateQuantityAdjustmentReturn =>
  useCreateAdjustmentBase<
    CreateInventoryQuantityAdjustmentMutation,
    CreateInventoryQuantityAdjustmentMutationVariables,
    CreateAdjustQuantityInput
  >({
    documentNode: CreateInventoryQuantityAdjustmentDocument,
    getOutput: (data) => data.inventoryAdjustment.adjustQuantity,
  })
